import { render, staticRenderFns } from "./GamePreview.vue?vue&type=template&id=433a06ca&scoped=true"
import script from "./GamePreview.vue?vue&type=script&lang=js"
export * from "./GamePreview.vue?vue&type=script&lang=js"
import style0 from "./GamePreview.vue?vue&type=style&index=0&id=433a06ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433a06ca",
  null
  
)

export default component.exports